import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function createFailure(draft: Draft<IManufacturerData>) {
  draft.create.config.isLoading = false;
}

export default createFailure;
